import {
  detachLayoutProps,
  WSElement,
  WSList,
  WSMarginProps,
  WSPanel,
  WSPill,
  WSPillProps,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { RequirementReviewPolicy } from "@wingspanhq/wingspan-api-sdk";

import {
  REVIEW_STRATEGY_ALWAYS_REQUIRED_COPY,
  REVIEW_STRATEGY_NEVER_REQUIRED_COPY,
  REVIEW_STRATEGY_ON_FAIL_COPY
} from "../CreateRequirementDefinitionForm/utils";

type Props = {
  reviewStrategy: RequirementReviewPolicy | undefined;
} & WSMarginProps;

const mapReviewStrategy: Record<
  RequirementReviewPolicy,
  (WSPillProps & { helperText: string }) | undefined
> = {
  [RequirementReviewPolicy.ALWAYS_REQUIRED]: {
    theme: "blue",
    text: "Approvals on",
    icon: "check-circle",
    helperText: REVIEW_STRATEGY_ALWAYS_REQUIRED_COPY
  },
  [RequirementReviewPolicy.ON_FAIL]: {
    theme: "blue",
    text: "Approvals on",
    icon: "alert-circle",
    helperText: REVIEW_STRATEGY_ON_FAIL_COPY
  },
  [RequirementReviewPolicy.NEVER_REQUIRED]: {
    theme: "neutral",
    text: "Approvals off",
    icon: "minus-circle",
    helperText: REVIEW_STRATEGY_NEVER_REQUIRED_COPY
  }
};

export const ApprovalWidget: React.FC<Props> = ({
  reviewStrategy = RequirementReviewPolicy.NEVER_REQUIRED,
  ...other
}) => {
  const { layoutProps } = detachLayoutProps(other);

  const props = mapReviewStrategy[reviewStrategy];

  if (!props) {
    return null;
  }

  const { helperText, ...pillProps } = props;

  return (
    <WSElement {...layoutProps}>
      <WSSectionToolbar title="Approvals" />
      <WSPanel mt="M">
        <WSList gap="L">
          <WSText.ParagraphSm color="gray500">Approvals</WSText.ParagraphSm>
          <WSElement>
            <WSPill {...pillProps} />
            <WSText.ParagraphXs color="gray500" mt="S">
              {helperText}
            </WSText.ParagraphXs>
          </WSElement>
        </WSList>
      </WSPanel>
    </WSElement>
  );
};
